import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { freeTrialVerifySmsCacheKeys } from "./constants";
import type { VerifySmsPayload } from "./types";

export const verifySms = reactQueryMutationAdapter(
  freeTrialVerifySmsCacheKeys,
  async (payload: VerifySmsPayload): Promise<any> => {
    return fetch(`/free_trial/verify_sms`, "POST", payload, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
